import axios from "axios";
import NProgress from "nprogress";

const API_URL = process.env.VUE_APP_APIADMINURL;

// create a new axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

function clearAuthAndRedirectToLogin() {
  localStorage.removeItem("jwt_token");
  localStorage.removeItem("tkutim");
  localStorage.removeItem("user");
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
}

// before a request is made start the nprogress
axiosInstance.interceptors.request.use((config) => {
  NProgress.start();
  const token = localStorage.getItem("jwt_token");
  if (token && token !== "null" && token !== "undefined") {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// before a response is returned stop nprogress
axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    if (error.response && error.response.status === 401) {
      clearAuthAndRedirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
